import { motion } from "framer-motion";
import { Calendar, Phone, MessageCircle } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="py-24 md:py-32 bg-[#1E3F33] relative overflow-hidden"
    >
      {/* Subtle background texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("https://static.prod-images.emergentagent.com/jobs/ee09a0c9-3169-45e7-b107-6fcbbe1b2a0b/images/6b84b4a45ec2083ddb32d73436889c9a523bfacc179fb3f45ec05679423045c1.png")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-6">
            Take the First Step
          </p>
          <h2
            data-testid="final-cta-heading"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F9F9F6] leading-tight max-w-3xl mx-auto mb-6"
          >
            Consult the Best Gynecologic Oncologist in Kolkata Today
          </h2>
          <p className="text-base sm:text-lg text-[#8FA998] max-w-xl mx-auto leading-relaxed mb-10">
            Early diagnosis and expert treatment can significantly improve outcomes in gynecologic cancers. Book a consultation with Dr. Neha Agarwal for accurate diagnosis, advanced treatment, and compassionate care.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/book-appointment"
              data-testid="final-cta-book-btn"
              className="inline-flex items-center gap-2 bg-[#F9F9F6] text-[#1E3F33] px-8 py-4 rounded-full text-sm font-bold hover:bg-[#E6E7E2] transition-colors duration-200"
            >
              <Calendar className="w-4 h-4" />
              Book Appointment
            </a>
            <a
              href="tel:+916291000829"
              data-testid="final-cta-call-btn"
              className="inline-flex items-center gap-2 border-2 border-[#F9F9F6] text-[#F9F9F6] px-8 py-4 rounded-full text-sm font-bold hover:bg-[#F9F9F6] hover:text-[#1E3F33] transition-all duration-200"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
            <a
              href="https://wa.me/916291000829"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp-btn"
              className="inline-flex items-center gap-2 bg-[#2C5545] text-[#F9F9F6] px-8 py-4 rounded-full text-sm font-bold hover:bg-[#8FA998]/30 transition-colors duration-200"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
